
'use strict';//Indicating browser should run only in java script mode


EMRCommonReasonstoRemove.service('CommonRemoveReasonsService', ['$http', 'CommonService', function ($http, CommonService) {


// ############################################### COMMONLY USED DELETE REASONS POP UP WINDOW BLOCK START #######################################################

//============================  GET ALL DELETE REASONS LIST BLOCK START ============================
//*******PURPOSE: THIS METHOD IS USED TO GET ALL INSTRUCTIONS BASED ON INPUT GIVEN CATEGORY ITEM
//*******CREATED BY: PRASAD BABU
//*******CREATED DATE: 03/19/2015
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *****************************
this.commonDeleteReasonsGetReasonsListSavedBasedOnEmrModule = function (postData) {

    postData.practicemodel = EMRPracticeModel;
    //Changed Navigation Due to API Splitting 
    //Added by Santhi v on 18May2021
   // return CommonService.PostData('POST', CommonService.EMRClinicalManagement_Common() + "GetDeleteReasonsListBasedOnEMRModule", postData).then(function (result) { return result; });
    return CommonService.PostData('POST', CommonService.EHR_Reasons_API_GetDeleteReasonsListBasedOnEMRModule() + "GetDeleteReasonsListBasedOnEMRModule", postData).then(function (result) { return result; });
};
//============================  GET ALL DELETE REASONS LIST BLOCK END ============================


//============================  ADD DELETE REASONS BLOCK START ============================
//*******PURPOSE: THIS METHOD IS USED TO GET ALL INSTRUCTIONS BASED ON INPUT GIVEN CATEGORY ITEM
//*******CREATED BY: PRASAD BABU
//*******CREATED DATE: 03/19/2015
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *****************************
this.commonDeleteReasonsAddDeleteReason = function (postData) {

    postData.practicemodel = EMRPracticeModel;
    //SPECIFYING THAT IT IS A ACTION WCF CALL
    postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
    //Changed Navigation Due to API Splitting 
    //Added by Santhi v on 18May2021
    //return CommonService.PostData('POST', CommonService.EMRClinicalManagement_Common() + "AddDeleteReason", postData).then(function (result) { return result; });
    return CommonService.PostData('POST', CommonService.EHR_Reasons_API_AddDeleteReason() + "AddDeleteReason", postData).then(function (result) { return result; });
};
//============================  ADD DELETE REASONS BLOCK END ============================


//============================  UPDATE DELETE REASONS BLOCK START ============================
//*******PURPOSE: THIS METHOD IS USED TO GET ALL INSTRUCTIONS BASED ON INPUT GIVEN CATEGORY ITEM
//*******CREATED BY: PRASAD BABU
//*******CREATED DATE: 03/19/2015
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *****************************
this.commonDeleteReasonsUpdateDeleteReason = function (postData) {

    postData.practicemodel = EMRPracticeModel;
    //SPECIFYING THAT IT IS A ACTION WCF CALL
    postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
    //Changed Navigation Due to API Splitting 
    //Added by Santhi v on 18May2021
    //return CommonService.PostData('POST', CommonService.EMRClinicalManagement_Common() + "UpdateDeleteReason", postData).then(function (result) { return result; });
    return CommonService.PostData('POST', CommonService.EHR_Reasons_API_UpdateDeleteReason() + "UpdateDeleteReason", postData).then(function (result) { return result; });
};
//============================  UPDATE DELETE REASONS BLOCK END ============================


//============================  DELETE SELECTED REASON BLOCK START ============================
//*******PURPOSE: THIS METHOD IS USED TO GET ALL INSTRUCTIONS BASED ON INPUT GIVEN CATEGORY ITEM
//*******CREATED BY: PRASAD BABU
//*******CREATED DATE: 03/19/2015
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *****************************
this.commonDeleteReasonsDeleteSelectedReason = function (postData) {

    postData.practicemodel = EMRPracticeModel;
    //SPECIFYING THAT IT IS A ACTION WCF CALL
    postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
    //Changed Navigation Due to API Splitting 
    //Added by Santhi v on 18May2021
   // return CommonService.PostData('POST', CommonService.EMRClinicalManagement_Common() + "DeleteSelectedReason", postData).then(function (result) { return result; });
    return CommonService.PostData('POST', CommonService.EHR_Reasons_API_DeleteSelectedReason() + "DeleteSelectedReason", postData).then(function (result) { return result; });
};
//============================  DELETE SELECTED REASON BLOCK END ============================


    //============================  CHECK ENTERED PASSWORD IS CORRECT OR NOT BLOCK START ============================
    //*******PURPOSE: THIS METHOD IS USED TO CHECK PASSOWRD IS CORRECT OR NOT WHILE CHECKING THE CLAIM CATEGORY
    //*******CREATED BY: S.SUDHEER
    //*******CREATED DATE: 08/16/2016
    //*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *****************************
this.commonCheckPassword = function (postData) {

    postData.practicemodel = EMRPracticeModel;

    return CommonService.PostData('POST', CommonService.EMRPracticeManagement_Billing() + "HashData", postData).then(function (result) { return result; });
};
    //============================  CHECK ENTERED PASSWORD IS CORRECT OR NOT BLOCK START ============================


    // ############################################### COMMONLY USED DELETE REASONS POP UP WINDOW BLOCK START #######################################################


}]);